import React from "react";
import DataTable from "@/components/Datatable/Datatable";
import MainPageWrapper from "@/components/MainPageWrapper/MainPageWrapper";
import { useRegistrationsReport } from "../../hooks/useRegistrationsReport";
import { useDownloadRegistrationsReportCsv } from "../../hooks/useDownloadRegistrationsReportCsv";
import { registrationsReportColumns } from "../RegistrationsReportColumns/RegistrationsReportColumns";
import RegistrationsReportFilters from "../RegistrationsReportFilters/RegistrationsReportFilters";
import { RegistrationsReportItem } from "../../api/fetchRegistrationsReport/types";

const columns = registrationsReportColumns();

const RegistrationsReportPage: React.FC = () => {
  const {
    items,
    totalCount,
    loading,
    error,
    pagination,
    sorting,
    filters,
    exportParams,
    handlePaginationChange,
    handleSortingChange,
    handleFilterChange,
  } = useRegistrationsReport();

  const { loading: csvLoading, downloadCsv } = useDownloadRegistrationsReportCsv();

  return (
    <MainPageWrapper title="Registrations Report">
      <RegistrationsReportFilters
        filters={filters}
        isExporting={csvLoading}
        onExportCsv={() => downloadCsv(exportParams)}
        onFilterChange={handleFilterChange}
      />
      <DataTable<RegistrationsReportItem>
        columns={columns}
        data={items}
        error={error}
        loading={loading}
        noDataMessage="No registrations found"
        onPageChange={(newPageIndex, newPageSize) =>
          handlePaginationChange({
            pageIndex: newPageIndex,
            pageSize: newPageSize,
          })
        }
        onSortingChange={handleSortingChange}
        pageIndex={pagination.pageIndex}
        pageSize={pagination.pageSize}
        rowKeyExtractor={(_row, index) => `${pagination.pageIndex}-${index}`}
        sorting={sorting}
        totalCount={totalCount}
      />
    </MainPageWrapper>
  );
};

export default RegistrationsReportPage;
